export const REFERENCE_STATUS = {
  friend: 'Friend',
  coworker: 'Work Colleague',
  classmate: 'Classmate',
  client: 'Client',
  other: 'Other',
}
